import React from "react";

type Props = {
    link: {
        url: string;
        name: string;
    };
};

const ContentBlockLink = ({ link }: Props) => {
    return <a href={link.url}>{link.name}</a>;
};

export default ContentBlockLink;
